// components
import { GridCompact6 } from 'components/shared/Grid/Grid.components';
import SectionHeader from '../SectionHeader/SectionHeader';
import { Icon } from '@sdb/planning-ui';

// styles
import { SpacedBox } from '../../AppointmentForm.styles';

// hooks
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { type RefObject, useCallback } from 'react';

// consts
import DateTimePeriodSection from './components/DateTimePeriodSection/DateTimePeriodSection';
import RecurrencePatternBuilder from '../RecurrencePatternBuilder/RecurrencePatternBuilder';

// types
import type { AppointmentFormFieldData } from '../../AppointmentForm.types';
import type { CustomSelectRef } from 'components/shared/Select';
import type { RecurrencePattern } from '../RecurrencePatternBuilder/RecurrencePatternBuilder.types';

type WhenSectionProps = {
  recurrenceFieldRef?: RefObject<CustomSelectRef | null>;
};

const WhenSection = ({ recurrenceFieldRef }: WhenSectionProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'mrp.appointmentForm' });

  const { control, setValue } = useFormContext<AppointmentFormFieldData>();
  const start = useWatch({ name: 'start', control });
  const end = useWatch({ name: 'end', control });
  const recurrencePattern = useWatch({ name: 'recurrencePattern', control });
  const allowedToEditRecurrenceRule = useWatch({
    name: 'allowedToEditRecurrenceRule',
    control
  });

  const id = useWatch({ name: 'id', control });
  const isExistingAppointment = !!id;

  const handlePatternChange = useCallback(
    (pattern: RecurrencePattern) =>
      setValue('recurrencePattern', pattern, {
        shouldDirty: true,
        shouldValidate: true
      }),
    [setValue]
  );

  return (
    <GridCompact6>
      <SectionHeader
        label={t('when')}
        icon={<Icon type="calendar" fontSize="inherit" />}
      />
      <SpacedBox>
        <DateTimePeriodSection />
        <RecurrencePatternBuilder
          date={start!}
          isExistingAppointment={isExistingAppointment}
          allowedToEditRecurrenceRule={allowedToEditRecurrenceRule}
          pattern={recurrencePattern}
          minPatternEnd={end!}
          onPatternChange={handlePatternChange}
          recurrenceFieldRef={recurrenceFieldRef}
        />
      </SpacedBox>
    </GridCompact6>
  );
};

export default WhenSection;
